import {useEffect,useRef,useState,useContext} from 'react'
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { LanguageContext } from '../../context';
import './SearchHeader.css'
import Translate, { useTranslate } from '../Translate/Translate';

const SearchHeader = () => {

  const [searchText,setSearchText]=useState('');
  const [isOpen,setIsOpen]=useState(false);
  const searchInputRef=useRef(null);
  const searchButtonRef=useRef(null);
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();
  const searchLabel=useTranslate('Search');
  const toggleSearchLabel=useTranslate(isOpen?'CloseSearch':'OpenSearch');

  useEffect(()=>{
    if(isOpen)
      searchInputRef.current?.focus();
  },[isOpen])

  const handleClickSearch=()=>{
    setIsOpen(!isOpen);
  }

  const handleChange=(e)=>{
    setSearchText(e.target.value);
  }

  const checkEnter=(e)=>{
    if(e.key=="Escape"){
      setIsOpen(false);
      searchButtonRef.current?.focus();
    }
  }

  const searchHandle=(e)=>{
    e?.preventDefault();
    navigate(`/?k=${searchText}`)
  }

  return (
    <form className='search-header-container' role="search" onSubmit={searchHandle}>
        <button
          type="button"
          className="search-icon"
          title={toggleSearchLabel}
          aria-label={toggleSearchLabel}
          aria-expanded={isOpen}
          aria-controls="search-header-panel"
          onClick={handleClickSearch}
          ref={searchButtonRef}
        >
            <span className="search-button" aria-hidden="true"></span>
        </button>
       <div id="search-header-panel" className={isOpen?'txt-search':'close txt-search'}>
         <TextField id="search-header-input" inputRef={searchInputRef} label={<Translate>SearchHeaderLable</Translate>} variant="standard" value={searchText} onChange={handleChange} onKeyDown={checkEnter} inputProps={{'aria-label':searchLabel}} />
       </div>
    </form>
  )
}

export default SearchHeader